import * as tslib_1 from "tslib";
import React from 'react';
import styled from 'styled-components';
import AdvancedTextInput from './AdvancedTextInput';
import Field from './Field';
export var StyledTextInput = styled(AdvancedTextInput)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding-top: 4px;\n"], ["\n  padding-top: 4px;\n"])));
/**
 * 输入框
 */
export default function TextInput(props) {
    return (React.createElement(Field, tslib_1.__assign({}, props, { render: function (_a) {
            var field = _a.field, form = _a.form;
            return (React.createElement(StyledTextInput, tslib_1.__assign({}, props, field, { error: form.touched[field.name] && form.errors[field.name], value: field.value ||
                    (props.value && form.setFieldValue(field.name, props.value)), onChange: function (value) {
                    form.setFieldValue(field.name, value);
                    props.onChange && props.onChange(value, form);
                }, id: field.name, onBlur: function (event) {
                    field.onBlur(event);
                    if (props.onBlur) {
                        props.onBlur(event);
                    }
                } })));
        } })));
}
var templateObject_1;
//# sourceMappingURL=TextInput.js.map